import { createApp } from 'vue'
import App from './App.vue'
import store from "./store"
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from "./router"
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// import provinces from "@/jsons/provinces.json"
// import cities from "@/jsons/cities.json"
// import areas from "@/jsons/areas.json"
// import streets from "@/jsons/streets.json"
import addr from "@/jsons/pcas-code.json";
import VueClipboard from 'vue-clipboard2';
//import VueRouter from 'vue-router';



const app = createApp(App)
app.provide('addr', {
  addr : addr
})

Date.prototype.Format = function (fmt) { //author: meizz 
  var o = {
      "M+": this.getMonth() + 1, //月份 
      "d+": this.getDate(), //日 
      "h+": this.getHours(), //小时 
      "m+": this.getMinutes(), //分 
      "s+": this.getSeconds(), //秒 
      "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
      "S": this.getMilliseconds() //毫秒 
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
  if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}
// const reg_address = "(?<province>[^省]+自治区|.*?省|.*?行政区|.*?市)(?<city>[^市]+自治州|.*?地区|.*?行政单位|.+盟|市辖区|.*?市|.*?县)(?<county>[^县]+县|.+?(区{1})|.+市|.+旗|.+海域|.+岛)?(?<village>.*)";
// // const regex = /^(?<province>[^省]+省|[^省]+自治区|[^省]+行政区|[^省]+市)(?<city>[^市]+市|[^市]+自治州)(?<county>[^区]+区|[^县]+县)(?<village>.*)/;
// const regex = /^(?<province>[^省]+省|[^省]+自治区|[^省]+市)(?<city>[^市]+市|[^市]+自治州|东莞市|中山市)(?<county>(?:[^县]+县|[^区]+区|[^市]+市|[^镇]+镇)?)(?<village>.+)$/;
String.prototype.formattAddress = function() {
  // 预处理：移除重复信息和电话
  let cleanAddr = this
    .replace(/(北京|天津|上海|重庆)\1(市|省)?/g, '$1$2')
    .split(",")[0];
  
  // 优化后的主正则表达式 - 关键改进在市级匹配
// const regex = /^(?<province>北京市|上海市|天津市|重庆市|[^省]+省|[^省]+自治区|[^省]+市)(?<city>(?:北京市|上海市|天津市|重庆市|[^市]+(?:市|自治州)|东莞市|中山市))(?<county>[^区县市镇]+(?:新区|区|自治县|县|市|镇))(?<village>.*)$/;
   const regex = /^(?<province>北京市|上海市|天津市|重庆市|[^省]+省|[^省]+自治区|[^省]+市)(?<city>(?:北京市|上海市|天津市|重庆市|[^市]+(?:市|自治州)|东莞市|中山市))(?<county>[^区县市镇旗]+(?:新区|区|县|市|镇|旗))(?<village>.*)$/;  
   const match = cleanAddr.match(regex);
  console.log(match)
  if (!match) {
    // 尝试备选匹配方案
    return alternativeParse(cleanAddr);
  }
  
  let { province, city, county, village } = match.groups;
  
  // 直辖市智能处理
  const isMunicipality = ["北京市", "上海市", "天津市", "重庆市"].includes(province);
  if (isMunicipality) {
    if (city === province) city = null;
    
    // 优化：防止区级信息被错误包含在详细地址中
    if (village.startsWith(county)) {
      village = village.substring(county.length).trim();
    }
  }
  
  return {
    province,
    city: city || (isMunicipality ? province : ""),
    county,
    village
  };
}

// 备选匹配方案 - 针对特殊情况的处理
function alternativeParse(address) {
  // 尝试匹配直辖市结构
  const muniRegex = /^(?<province>北京市|上海市|天津市|重庆市)(?<county>[^区县市镇旗]+(?:新区|区|县|市|镇|旗))(?<village>.*)$/;
  const muniMatch = address.match(muniRegex);
  
  if (muniMatch) {
    return {
      province: muniMatch.groups.province,
      city: muniMatch.groups.province, // 直辖市时city=province
      county: muniMatch.groups.county,
      village: muniMatch.groups.village
    };
  }
  
  // 尝试匹配直筒子市结构
  const directCityRegex = /^(?<province>[^省]+省)(?<city>东莞市|中山市)(?<county>[^区县市镇]+镇)(?<village>.*)$/;
  const directMatch = address.match(directCityRegex);
  
  if (directMatch) {
    return directMatch.groups;
  }
  
  // 最后尝试：简单分割
  const parts = address.split(/(省|市|区|县|镇)/);
  return {
    province: parts[0] + (parts[1] || ""),
    city: parts[2] + (parts[3] || ""),
    county: parts[4] + (parts[5] || ""),
    village: parts.slice(6).join("")
  };
}

String.prototype.extractInfo = function () {
    // 验证是否为有效中文姓名（2-4个中文字符）
    function isValidName(str) {
        return /^[\u4e00-\u9fa5]{1,4}$/.test(str);
    }

    // 匹配11位手机号（可能带分机号）
    const phoneMatch = this.match(/\d{11}(?:-\d+)?/);
    if (!phoneMatch) return { phone: '', name: '', address: '' };
    
    const fullPhone = phoneMatch[0];
    const phone = fullPhone.slice(0, 11);  // 提取纯11位手机号
    const phoneStart = phoneMatch.index;
    const phoneEnd = phoneStart + fullPhone.length;
    
    // 分割字符串
    let front = this.slice(0, phoneStart).trim();
    let rear = this.slice(phoneEnd).trim();
    
    // 清理两端的分隔符
    const cleanPart = (part) => part.replace(/^[,，、；;\s]+|[,，、；;\s]+$/g, '');
    front = cleanPart(front);
    rear = cleanPart(rear);
    
    let name = '';
    let address = '';
    
    // 情况1：手机号在中间（前后都有内容）
    if (front && rear) {
        name = front;
        address = rear;
    } 
    // 情况2：手机号在开头（前面无内容，后面有内容）
    else if (!front && rear) {
        // 智能分割后段内容
        const parts = rear.split(/[,，、；;]+/).map(p => p.trim()).filter(p => p);
        
        if (parts.length === 1) {
            // 只有一部分：整个作为地址
            address = rear;
        } else if (parts.length > 1) {
            // 尝试识别姓名部分（2-4个中文字符）
            const findNameIndex = () => {
                // 优先检查开头部分
                if (isValidName(parts[0])) return 0;
                // 其次检查结尾部分
                if (isValidName(parts[parts.length - 1])) return parts.length - 1;
                // 最后检查中间部分
                for (let i = 1; i < parts.length - 1; i++) {
                    if (isValidName(parts[i])) return i;
                }
                return -1;
            };
            
            const nameIndex = findNameIndex();
            if (nameIndex >= 0) {
                name = parts[nameIndex];
                address = parts.filter((_, i) => i !== nameIndex).join(' ');
            } else {
                // 无法识别姓名，整个作为地址
                address = rear;
            }
        }
    }
    // 情况3：手机号在末尾（后面无内容，前面有内容）
    else if (front && !rear) {
        // 智能分割前段内容
        const parts = front.split(/[,，、；;]+/).map(p => p.trim()).filter(p => p);
        
        if (parts.length === 1) {
            // 只有一部分：整个作为地址
            address = front;
        } else if (parts.length > 1) {
            // 尝试识别姓名部分（2-4个中文字符）
            const findNameIndex = () => {
                // 优先检查开头部分
                if (isValidName(parts[0])) return 0;
                // 其次检查结尾部分
                if (isValidName(parts[parts.length - 1])) return parts.length - 1;
                // 最后检查中间部分
                for (let i = 1; i < parts.length - 1; i++) {
                    if (isValidName(parts[i])) return i;
                }
                return -1;
            };
            
            const nameIndex = findNameIndex();
            if (nameIndex >= 0) {
                name = parts[nameIndex];
                address = parts.filter((_, i) => i !== nameIndex).join(' ');
            } else {
                // 无法识别姓名，整个作为地址
                address = front;
            }
        }
    }
    
    return { phone, name, address };
}

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// ElementPlusIconsVue.forEach((item,key )=> {
//     app.component(key,item)
// });
app.use(ElementPlus).use(router.router).use(store).use(VueClipboard)
app.mount('#app')
